import instanceQuery from 'graphql/queries/salesLedger/SalesBadDebtTransactionQuery.graphql';
import fragment from 'graphql/fragments/nominal/PostedTransactionsFragment.graphql';

const SalesBadDebtTransactions = {
  type: 'PostedTransactionsResponse',
  formTitle: 'Posted Transactions',
  instance: instanceQuery,
  fragment,
};

export default SalesBadDebtTransactions;
